import React, { useEffect, useState } from 'react';
import styles from './Home.module.css';
import classes from '../../globaFunctions/globalStyles.module.css';
import { Col, Modal, Progress, Row, Image, Typography, Tabs, Layout } from 'antd';
import ReactMarkdown from 'react-markdown';

import data from './db.json'

import { getImage } from '../../globaFunctions';
import useWindowSize from "../../globaFunctions/useWindowSize";

const years = [2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011, 2010, 2008, 2005]
const { TabPane } = Tabs;

const Home = (props: any) => {
    const { width } = useWindowSize();
    const isMobile = width <= 500;

    var monthYear = ''
    var cardTime: any = []
    var cardTime0: any = []
    var cardTime1: any = []

    const [cardID, setCardID]: any = useState([])
    const [cardID0, setCardID0]: any = useState([])
    const [cardID1, setCardID1]: any = useState([])
    // var selectedId7: any = []

    const [cardDistance, setCardDistance]: any = useState([])
    const [cardDistance0, setCardDistance0]: any = useState([])
    const [cardDistance1, setCardDistance1]: any = useState([])

    useEffect(() => {
        // console.log(cardTime0);
        setTimeout(() => {
            // cardTime0 = cardTime.cardId.filter((d, i) => d.id % 2 === 0);
            // console.log(cardTime0);
            if (cardTime0.length !== 0) {
                var test4: any = [...cardDistance0];
                for (var i = 0; i < cardTime0.length; i++) {
                    test4.push({
                        id: cardTime0[i].id,
                        distance: getPosition(cardTime0[i].id).y,
                        cardId: cardTime0[i].cardId
                    })
                }
                setCardDistance0(test4)
            }
        }, 1000);
        // console.log(selectedId3);
    }, [])

    useEffect(() => {
        // console.log(cardTime1);
        setTimeout(() => {
            // cardTime1 = cardTime.cardId.filter((d, i) => d.id % 2 === 0);
            if (cardTime1.length !== 0) {
                var test4: any = [...cardDistance1];
                for (var i = 0; i < cardTime1.length; i++) {
                    test4.push({
                        id: cardTime1[i].id,
                        distance: getPosition(cardTime1[i].id).y,
                        cardId: cardTime1[i].cardId
                    })
                }
                setCardDistance1(test4)
            }
        }, 1000);
        // console.log(selectedId6);
    }, [])

    const getPosition = (element) => {
        var docElement: any = document.getElementById(element)
        var xPosition = 0;
        var yPosition = 0;

        while (docElement) {
            xPosition += (docElement.offsetLeft - docElement.scrollLeft + docElement.clientLeft);
            yPosition += (docElement.offsetTop - docElement.scrollTop + docElement.clientTop);
            docElement = docElement.offsetParent;
        }

        return { x: xPosition, y: yPosition };
    }

    function fillSkills(zo) {
        //console.log(data.cards);
        return (
            data.cards.map((d: any, j: any) => {
                return (
                    <div key={j} style={{
                        borderLeft: zo === 1 ? `5px solid ${d.type === 'startup' ? "red" : (d.type === 'work' ? "yellow" : "green")}` : ``,
                        borderRight: zo === 0 ? `5px solid ${d.type === 'startup' ? "red" : (d.type === 'work' ? "yellow" : "green")}` : ``,
                        // marginTop: d.id === 2 ? 30 : d.id === 4 ? 20 : d.id === 6 ? 20 : 0
                        marginTop:  d.id === 1 ? 88 : d.id === 3 ? 40 : d.id === 5 ? -60 : d.id === 15 ? 180 : d.id === 0 ? 80 : d.id === 2 ? 80 : d.id === 4 ? 54 : d.id === 6 ? 114 : d.id === 12 ? 200 : d.id === 14 ? 62 : 20,
                        marginRight: zo === 1 ? '10px' : '0',
                        marginLeft: zo === 0 ? '10px' : '0',
                    }}>
                        {Object.keys(d.skills).map((s, i) => {
                            const value: any = Object.values(d.skills)[i]
                            return (
                                d.id % 2 === zo &&
                                <div key={`${i}${j}`} style={{
                                    marginRight: zo === 0 ? '5px' : '0',
                                    marginLeft: zo === 1 ? '5px' : '0',
                                    height: '39px'
                                }}>
                                    <p style={{marginBottom: -5, marginTop: i !== 0 ? 10 : 0 }}>
                                        {s}
                                    </p>
                                    <Progress className={d.type === 'startup' ? "red_progress" : (d.type === 'work' ? "yellow_progress" : "green_progress")} percent={parseInt(value)} size="small" />
                                </div>
                            )
                        })}
                    </div>
                )
            })
        )
    }

    function fillCards(zo) {
        return (
            data.cards.map((d: any, i: any) => {
                return (
                    d.id % 2 === zo ?
                        <div key={i} style={{
                            // marginTop: i !== 0 ? 40 : 0,
                            justifyContent: "flex-end",
                            position: "absolute",
                            width: (d.id === 24) ? '95%' : '100%',
                            top: ((zo === 0 ? cardDistance0 : zo === 1 ? cardDistance1 : cardDistance).length !== 0 && (zo === 0 ? cardDistance0 : zo === 1 ? cardDistance1 : cardDistance).find((b) => b.cardId === d.id)) ? ((zo === 0 ? cardDistance0 : zo === 1 ? cardDistance1 : cardDistance).find((b) => b.cardId === d.id).distance - 40) : 0,
                            marginTop: d.id === 4 ? 80 : d.id === 8 ? 20 : d.id === 10 ? 560 : d.id === 12 ? 420 : d.id === 5 ? 0 : d.id === 7 ? 330 : d.id === 9 ? 95 : d.id === 11 ? 60 : d.id === 13 ? 300: 0,
                            // marginTop: (selectedId7.length !== 0 && selectedId7.filter((item) => item === d.id).length !== 0) ? (selectedId7.filter((item) => (parseInt(item) < parseInt(d.id)) && d.id % 2 === 0).length ? ((selectedId7.filter((item) => parseInt(item) < parseInt(d.id)).length)) * 100 : 0) : 0
                            // marginTop: d.id === 4 ? 60 : d.id === 8 ? 40 : d.id === 6 ? -137 : d.id === 10 ? 365 : d.id === 12 ? 570 : d.id === 14 ? 83 : (test5.length === 1 && test5[0].indexOf(d.id) !== 0 && test5[0].indexOf(d.id) !== -1) ? test5[0].indexOf(d.id) * 250 : (test5.length > 1 && test5[test5.length - 1].indexOf(d.id) !== 0 && test5[test5.length - 1].indexOf(d.id) !== -1) ? test5[test5.length - 1].indexOf(d.id) * 250 : 0
                        }}>
                            <Col style={{
                                border: `5px solid ${d.type === 'startup' ? "red" : d.type === 'work' ? "yellow" : "green"}`,
                                borderRight: 0,
                                borderLeft: 0,
                                borderBottom: 0,
                                // borderTopLeftRadius: 5,
                                height: 50
                                // }} span={24} className={[styles.container].join(' ')}>
                            }} span={24} className={[styles.container, d.type === 'startup' ? styles.container_red : (d.type === 'work' ? styles.container_yellow : styles.container_green)].join(' ')}>
                                <Row>
                                    <Col span={5} >
                                        <img height='40px' width='40px' src={getImage(d.logo)} alt={d.logo} />
                                    </Col>
                                    <Col span={18}>
                                        <Row >
                                            <Layout.Content style={{ margin: '2px 12px 0' }}> 
                                                <span className={styles.timeTxt}>{d.date[0]}</span>{d.date[1] && <span className={styles.timeTxt}> - {d.date[1]}</span>}
                                            </Layout.Content>
                                        </Row>
                                        <Row className={styles.titleTxt}>
                                            <Layout.Content style={{ margin: '2px 12px 0' }}> 
                                                {d.location}
                                            </Layout.Content>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <p className={styles.secondTitleTxt}>
                                        {d.title}
                                    </p>
                                </Row>
                                <Row >
                                    <Typography.Text style={{ height: '100%', wordWrap: 'break-word'}}>
                                        <ReactMarkdown>{d.short_description}</ReactMarkdown>
                                        {/* {d.short_description} */}
                                    </Typography.Text>
                                </Row>
                                <Row>
                                    <p onClick={() => { setSelectedRecord(d); setModalVisible(true) }} className={styles.readMore}>read more...</p>
                                </Row>
                            </Col>

                        </div>
                        : <> </>
                )
            })
        )
    }

    function fillTimebars(zo) {
        var card: any = []
        if (zo === 0 || zo === 1) {
            card = data.cards.filter((d, i) => d.id % 2 === zo);
        }
        else {
            card = data.cards;
        }
        var dateNow = new Date().toISOString().slice(0, 7)
        // console.log(dateNow)
        return (
            years.map((y, i) => {
                return (
                    ['12', '11', '10', '09', '08', '07', '06', '05', '04', '03', '02', '01'].map((m, j: any) => {
                        var dateLoop = new Date(`${y}-${m}`).toISOString().slice(0, 7)
                        // console.log(new Date(`${y}-${m}`),dateLoop)
                        const selectedDate = card.map((l, x) => { 
                            var cardD0 = new Date(card[x].date[0]).toISOString().slice(0, 7)
                            var cardD1 = new Date(card[x].date[1]).toISOString().slice(0, 7)
                            // console.log(new Date(card[x].date[0]),cardD0, new Date(card[x].date[1]),cardD1)
                            return (((cardD0 <= dateLoop) && (card[x].date[1] ? dateLoop <= cardD1 : dateLoop <= dateNow)) ? card[x].type === 'startup' ? { id: l.id, color: 'red' } : (card[x].type === 'work' ? { id: l.id, color: 'yellow' } : { id: l.id, color: 'green' }) : '') })
                        
                        const isSelectedDate = selectedDate.findIndex(w => w.color);
                        const isSelectedDate2 = selectedDate.filter(w => w.color);
                        // console.log(selectedDate)
                        if (isSelectedDate2.length > 1) {
                            var test2: any = []
                            if (zo === 0) {
                                test2 = [...cardID0]
                            }
                            else if (zo === 1) {
                                test2 = [...cardID1]
                            }
                            else{
                                test2 = [...cardID]
                            }
                            // const test2 = [...list[`cardID${n}`]]
                            var test: any = [];
                            for (var g = 0; g < selectedDate.length; g++) {
                                if (selectedDate[g].id) {
                                    test.push(selectedDate[g].id)
                                    //     if (selectedDate[g].id && selectedId7.filter(n => n === selectedDate[g].id).length === 0) {
                                    //         const test = [...selectedId7]
                                    //         test.push(selectedDate[g].id)
                                    //         setSelectedId7(test)
                                    //     }
                                }
                            }
                            if (test2.filter(n => JSON.stringify(n) === JSON.stringify(test)).length !== 0) {
                                // console.log('no')
                            } else {
                                test2.push(test)
                                if (zo === 0) {
                                    setCardID0(test2)
                                }
                                else if (zo === 1) {
                                    setCardID1(test2)
                                }
                                else{
                                    setCardID(test2)
                                }
                                // setList[`CardID${n}`](test2)
                            }
                        }
                        if (isSelectedDate !== -1) {
                            for (var f = 0; f < selectedDate.length; f++) {
                                if (selectedDate[f].id > -1) {
                                    // list[`cardTime${n}`].push({
                                    cardTime.push({
                                        id: `${i}${j}`,
                                        cardId: selectedDate[f].id,
                                    })
                                    monthYear = `${i}${j}`
                                    if (zo === 0) {
                                        cardTime0.push({
                                            id: `${i}${j}`,
                                            cardId: selectedDate[f].id,
                                        })
                                        // setCardTime0([...cardTime])
                                        //setCardID0(cardID)
                                    }
                                    else if (zo === 1) {
                                        cardTime1.push({
                                            id: `${i}${j}`,
                                            cardId: selectedDate[f].id,
                                        })
                                        // setCardTime1([...cardTime])
                                        //setCardID1(cardID)
                                    }
                                }
                            }
                        }
                        else if (isSelectedDate === -1 && monthYear) {
                            monthYear = ''
                        }
                        // console.log(selectedDate[isSelectedDate])                        
                        return (
                            <Col span={2} key={`${i}${j}`}>
                                <div
                                    id={`${i}${j}`}
                                    style={{
                                        height: 240 / 12,
                                        background: isSelectedDate !== -1 ? selectedDate[isSelectedDate].color : '',
                                        width: 5,
                                        zIndex: 9999999999
                                    }}>
                                </div>
                            </Col>
                        )
                    })
                )
            })
        )
    }

    function fillYears() {
        return (
            years.map((y) => {
                return (
                    <div key={y} style={{ height: 240, display: "flex", justifyContent: 'flex-end', alignItems: 'flex-end' }} >
                        <p className={styles.yearBtn}>
                            {y}
                        </p>
                    </div>
                )
            })
        )
    }

    const fillModal = () => {
        return(
            <Modal
                title="Details"
                visible={modalVisible}
                closable={true}
                onCancel={() => setModalVisible(false)}
                footer={null}
                width={1000}>
                <Row className={classes.display_flex_row_space_between_align_first}>
                    <Col xs={24} xl={6} xxl={6} sm={24}>
                        <img width={80} height={80} src={getImage(selectedRecord.logo)} alt={selectedRecord.logo} />
                        <p>
                            {/* <span className={styles.timeTxt}>
                                {selectedRecord.date[0]}
                            </span> */}
                            {/* {selectedRecord.date[1] && <span className={styles.timeTxt}>
                                - {selectedRecord.date[1]}
                            </span>} */}
                        </p>
                        <p className={styles.short_description} 
                        style={{fontSize: isMobile ? '11px' : ''}}>
                            {selectedRecord.location}
                        </p>
                        <p className={styles.title} style={{marginBottom: '20px', fontSize: isMobile ? '11px' : ''}}>
                            {selectedRecord.title}
                        </p>
                    </Col>
                    <Col xs={24} xl={18} xxl={18} sm={24} style={{fontSize: isMobile ? '10px' : ''}}>
                        <Typography.Text style={{ height: '100%', wordWrap: 'break-word'}}>
                            <ReactMarkdown>{selectedRecord.full_description}</ReactMarkdown>
                        </Typography.Text>
                    </Col>
                </Row>
                <Row className={classes.display_flex_row_center}>
                    <Image src={getImage(selectedRecord.bg)} preview={false}>
                    </Image>
                </Row>
            </Modal>
        )
    }

    const [modalVisible, setModalVisible] = useState(false)
    const [selectedRecord, setSelectedRecord]: any = useState({})

    if (isMobile) {
        return (
            <Tabs defaultActiveKey="1" className={styles.mobile}>
                <TabPane tab="Work Experience" key="1">
                    <Row>
                        <Col span={8}>
                            {fillSkills(0)}
                        </Col>
                        <Col span={16} className={classes.display_flex_row_justify_center} style={{ alignItems: 'flex-start' }}>
                            <Col span={17} style={{ display: 'flex', flexDirection: "column", justifyContent: 'flex-end', flexShrink: 1 }}>
                                {fillCards(0)}
                            </Col>
                            <Col span={1}>
                                {fillTimebars(0)}
                            </Col>
                            <Col span={6} style={{ display: "flex", flexDirection: "column", justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                {fillYears()}
                            </Col>
                        </Col>
                        {fillModal()}
                    </Row >
                </TabPane>

                <TabPane tab="Education/Research" key="2">
                    <Row className={styles.wrapper}>
                        <Col span={16} className={classes.display_flex_row_justify_center} style={{ alignItems: 'flex-start' }}>
                            <Col span={6} style={{ display: "flex", flexDirection: "column", justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                {fillYears()}
                            </Col>
                            <Col span={1} style={{ direction: 'rtl' }}>
                                {fillTimebars(1)}
                            </Col>
                            <Col span={17} style={{ display: 'flex', flexDirection: "column", justifyContent: 'flex-end' }}>
                                {fillCards(1)}
                            </Col>
                        </Col>
                        <Col span={8}>
                            {fillSkills(1)}
                        </Col>
                        {fillModal()}
                    </Row >
                </TabPane>
            </Tabs>
          );
        } 
    else {
        return (
            <Row className={styles.wrapper}>
                <Col span={4}>
                    {fillSkills(0)}
                </Col>
                <Col span={15} className={classes.display_flex_row_justify_center} style={{ alignItems: 'flex-start' }}>
                    <Col span={10} style={{ display: 'flex', flexDirection: "column", justifyContent: 'flex-end', flexShrink: 1 }}>
                        {fillCards(0)}
                    </Col>
                    <Col span={1}>
                        {fillTimebars(0)}
                    </Col>
                    <Col span={2} style={{ display: "flex", flexDirection: "column", justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                        {fillYears()}
                    </Col>
                    <Col span={1} style={{ direction: 'rtl' }}>
                        {fillTimebars(1)}
                    </Col>
                    <Col span={10} style={{ display: 'flex', flexDirection: "column", justifyContent: 'flex-end' }}>
                        {fillCards(1)}
                    </Col>
                </Col>
                <Col span={4}>
                    {fillSkills(1)}
                </Col>
                {fillModal()}
            </Row >
        );
    }
}


export default Home;